// import { useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import { useState, useEffect } from 'react';
// import { followPlayer, unfollowPlayer } from '../../../features/coach/coachProfileSlice';

// export const PlayerRow = ({ player, followedPlayers = [], showNewSchool = false }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [isFollowing, setIsFollowing] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   // Check if player is in followed players list
//   useEffect(() => {
//     if (player?._id && followedPlayers && followedPlayers.length > 0) {
//       const isPlayerFollowed = followedPlayers.some(
//         (p) => p._id === player._id || p.id === player._id
//       );
//       setIsFollowing(isPlayerFollowed);
//     } else {
//       // Fallback to player.isFollowing if followedPlayers is not available
//       setIsFollowing(player.isFollowing || false);
//     }
//   }, [player, followedPlayers]);

//   const handleViewProfile = () => {
//     // Use player ID to navigate
//     const playerId = player._id || player.id || player.name.toLowerCase().replace(/\s+/g, '-');
//     navigate(`/coach/player/${playerId}`, {
//       state: {
//         from: 'uncommittedTracker',
//         playerData: {
//           ...player,
//           // Ensure team data is included
//           team: player.team
//         }
//       }
//     });
//   };

//   const handleFollowToggle = async (e) => {
//     e.stopPropagation();
//     const playerId = player._id;

//     setIsLoading(true);
//     try {
//       if (isFollowing) {
//         await dispatch(unfollowPlayer(playerId)).unwrap();
//         setIsFollowing(false);
//       } else {
//         await dispatch(followPlayer(playerId)).unwrap();
//         setIsFollowing(true);
//       }
//     } catch (error) {
//       console.error('Follow/Unfollow error:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Extract data from API response structure - matching new headers
//   const jpRank = player.jpRank || player.rank || '-';
//   const year = player.battingStats?.[0]?.seasonYear || player.pitchingStats?.[0]?.seasonYear || player.fieldingStats?.[0]?.seasonYear || '-';
//   const playerName = `${player.firstName || ''} ${player.lastName || ''}`.trim() || 'N/A';

//   // Handle position - prefer primaryPosition over position
//   const position = player.primaryPosition || player.position || '-';

//   const previousTeam = player.previousSchool || '-';
//   const currentTeam = player.team?.name || '-';
//   const newSchool = player.newSchool || player.committedTo || '-';
//   const newSchoolLogo = player.newSchoolLogo || player.committedSchoolLogo || null;
//   const playerClass = player.playerClass || player.class || '-';
//   const region = player.hometown || player.region || '-';
//   const playerScore = player.playerScore || '-';
//   const conferenceStrengthScore = player.conferenceStrengthScore || '-';

//   return (
//     <tr className="hover:bg-jp-section transition border-b border-jp-line">
//       {/* JP RANK */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-ink font-semibold text-[10px] sm:text-xs whitespace-nowrap">
//         {jpRank}
//       </td>

//       {/* YEAR */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
//         {year}
//       </td>

//       {/* NAME */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-ink text-[10px] sm:text-xs whitespace-nowrap">
//         {playerName}
//       </td>

//       {/* POSITION */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
//         {position}
//       </td>

//       {/* TEAM (Current) */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
//         {currentTeam}
//       </td>

//       {/* NEW SCHOOL - Only show when showNewSchool is true */}
//       {showNewSchool && (
//         <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
//           <div className="flex items-center gap-2 justify-center">
//             {newSchoolLogo && (
//               <img
//                 src={newSchoolLogo}
//                 alt={newSchool}
//                 className="w-5 h-5 sm:w-6 sm:h-6 object-contain rounded"
//                 onError={(e) => {
//                   e.target.style.display = 'none';
//                 }}
//               />
//             )}
//             <span>{newSchool}</span>
//           </div>
//         </td>
//       )}

//       {/* CLASS */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
//         {playerClass}
//       </td>

//       {/* REGION */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
//         {region}
//       </td>

//       {/* PLAYER SCORE */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-accent-ink font-semibold text-[10px] sm:text-xs whitespace-nowrap">
//         {playerScore}
//       </td>

//       {/* CONFERENCE STRENGTH SCORE */}
//       {/* <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-accent-ink font-semibold text-[10px] sm:text-xs whitespace-nowrap">
//         {conferenceStrengthScore}
//       </td> */}

//       {/* VIDEO */}
//       {/* <td className="px-2 sm:px-3 py-2 sm:py-3">
//         {hasVideo ? (
//           <button className="border border-white py-1 px-2 rounded-md text-cyan-200 bg-transparent hover:bg-cyan-900 text-[10px] sm:text-xs whitespace-nowrap transition font-medium">
//             Watch videos
//           </button>
//         ) : (
//           <span className="text-jp-muted text-[10px] sm:text-xs">-</span>
//         )}
//       </td> */}

//       {/* ACTIONS */}
//       <td className="px-2 sm:px-3 py-2 sm:py-3 sticky right-0 bg-jp-card z-10">
//         <div className="flex flex-row gap-1 sm:gap-2 min-w-[160px] sm:min-w-[180px]">
//           <button
//             onClick={handleViewProfile}
//             className="border border-jp-line bg-jp-section text-jp-ink py-1 px-2 sm:px-3 rounded-md text-[10px] sm:text-xs leading-tight hover:bg-jp-section transition whitespace-nowrap"
//           >
//             View profile
//           </button>
//           <button
//             onClick={handleFollowToggle}
//             disabled={isLoading}
//             className={`${
//               isFollowing
//                 ? 'bg-gray-600 hover:bg-gray-700'
//                 : 'bg-cyan-500 hover:bg-cyan-400'
//             } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''} text-white font-semibold py-1 px-2 sm:px-3 rounded-md text-[10px] sm:text-xs leading-tight transition whitespace-nowrap flex items-center justify-center gap-1`}
//           >
//             {isLoading ? (
//               <>
//                 <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                 <span>{isFollowing ? 'Unfollowing...' : 'Following...'}</span>
//               </>
//             ) : (
//               <span>{isFollowing ? 'Unfollow' : 'Follow'}</span>
//             )}
//           </button>
//         </div>
//       </td>
//     </tr>
//   );
// };






import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { followPlayer, unfollowPlayer } from '../../../features/coach/coachProfileSlice';

import { normalizePlayerClass } from '../../../utils/normalizePlayerClass';
import { openOnRowClick } from '../../../utils/rowClick';

// Year and Name are frozen on the left when the table scrolls sideways. Year has
// a fixed width so Name can sit right after it; the line marks the frozen edge.
export const FROZEN_YEAR = 'sticky left-0 w-[4.5rem] min-w-[4.5rem] max-w-[4.5rem]';
export const FROZEN_NAME = 'sticky left-[4.5rem] shadow-[inset_-1px_0_0_rgb(var(--jp-line))]';
const FROZEN_BG = 'bg-jp-card group-hover:bg-jp-section z-[5]';

export const PlayerRow = ({ player, followedPlayers = [], showNewSchool = false, dynamicStatColumns = [], getStatValue = null }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFollowing, setIsFollowing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Check if player is in followed players list
  useEffect(() => {
    if (player?._id && followedPlayers && followedPlayers.length > 0) {
      const isPlayerFollowed = followedPlayers.some(
        (p) => p._id === player._id || p.id === player._id
      );
      setIsFollowing(isPlayerFollowed);
    } else {
      // Fallback to player.isFollowing if followedPlayers is not available
      setIsFollowing(player.isFollowing || false);
    }
  }, [player, followedPlayers]);

  const handleViewProfile = () => {
    // Use player ID to navigate
    const playerId = player._id || player.id || player.name.toLowerCase().replace(/\s+/g, '-');
    navigate(`/coach/player/${playerId}`, {
      state: {
        from: 'uncommittedTracker',
        playerData: {
          ...player,
          // Ensure team data is included
          team: player.team
        }
      }
    });
  };

  const handleFollowToggle = async (e) => {
    e.stopPropagation();
    const playerId = player._id;

    setIsLoading(true);
    try {
      if (isFollowing) {
        await dispatch(unfollowPlayer(playerId)).unwrap();
        setIsFollowing(false);
      } else {
        await dispatch(followPlayer(playerId)).unwrap();
        setIsFollowing(true);
      }
    } catch (error) {
      console.error('Follow/Unfollow error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Extract data from API response structure - matching new headers
  // Get jpRank from player level or from battingStats/pitchingStats - show "NA" if not available
  const jpRank = player.jpRank || player.rank ||
    (Array.isArray(player.battingStats) ? player.battingStats[0]?.jpRank : player.battingStats?.jpRank) ||
    (Array.isArray(player.pitchingStats) ? player.pitchingStats[0]?.jpRank : player.pitchingStats?.jpRank) ||
    'NA';
  // const year = player.battingStats?.[0]?.seasonYear || player.pitchingStats?.[0]?.seasonYear || player.fieldingStats?.[0]?.seasonYear || '-';
   const year =  '2026'; // Temporarily hardcoding year to 2026
  const toTitleCase = (str) => str ? str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) : str;
  const playerName = toTitleCase(`${player.firstName || ''} ${player.lastName || ''}`.trim()) || 'N/A';

  // Handle position - prefer primaryPosition over position
  const position = player.primaryPosition || player.position || '-';

  const previousTeam = player.previousSchool || '-';
  const currentTeam = player.team?.name || '-';
  const newSchool = player.newSchool || player.committedTo || '-';
  const newSchoolLogo = player.newSchoolLogo || player.committedSchoolLogo || null;
  const playerClass = normalizePlayerClass(player.playerClass || player.class);
  const region = player.hometown || player.region || '-';

  // Get finalScore from battingStats as playerScore - show "NA" if not available
  const playerScore = (() => {
    const stats = Array.isArray(player.battingStats) ? player.battingStats[0] : player.battingStats;
    const score = stats?.finalScore;
    if (score === null || score === undefined || score === '') return 'NA';
    return score;
  })();

  return (
    <tr onClick={openOnRowClick(handleViewProfile)} className="group cursor-pointer hover:bg-jp-section transition border-b border-jp-line">
      {/* JP RANK */}
      {/* <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-ink font-semibold text-[10px] sm:text-xs whitespace-nowrap">
        {jpRank}
      </td> */}

      {/* YEAR */}
      <td className={`${FROZEN_YEAR} ${FROZEN_BG} px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap`}>
        {year}
      </td>

      {/* NAME */}
      <td className={`${FROZEN_NAME} ${FROZEN_BG} px-2 sm:px-3 py-2 sm:py-3 text-jp-ink text-[10px] sm:text-xs whitespace-nowrap`}>
        {playerName}
      </td>

      {/* POSITION */}
      <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
        {position}
      </td>

      {/* TEAM (Current) */}
      <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
        {currentTeam}
      </td>

      {/* NEW SCHOOL - Only show when showNewSchool is true */}
      {showNewSchool && (
        <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
          <div className="flex items-center gap-2 justify-center">
            {newSchoolLogo && (
              <img
                src={newSchoolLogo}
                alt={newSchool}
                className="w-5 h-5 sm:w-6 sm:h-6 object-contain rounded"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            )}
            <span>{newSchool}</span>
          </div>
        </td>
      )}

      {/* CLASS */}
      <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
        {playerClass}
      </td>

      {/* REGION */}
      <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-[10px] sm:text-xs whitespace-nowrap">
        {region}
      </td>

      {/* PLAYER SCORE */}
      {/* <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-accent-ink font-semibold text-[10px] sm:text-xs whitespace-nowrap">
        {playerScore}
      </td> */}

      {/* Dynamic stat columns */}
      {dynamicStatColumns.map((column, idx) => (
        <td key={`stat-${idx}`} className="px-2 sm:px-3 py-2 sm:py-3 text-jp-muted text-center text-[10px] sm:text-xs whitespace-nowrap">
          {getStatValue ? getStatValue(player, column) : '0'}
        </td>
      ))}

      {/* CONFERENCE STRENGTH SCORE */}
      {/* <td className="px-2 sm:px-3 py-2 sm:py-3 text-jp-accent-ink font-semibold text-[10px] sm:text-xs whitespace-nowrap">
        {conferenceStrengthScore}
      </td> */}

      {/* VIDEO */}
      {/* <td className="px-2 sm:px-3 py-2 sm:py-3">
        {hasVideo ? (
          <button className="border border-white py-1 px-2 rounded-md text-cyan-200 bg-transparent hover:bg-cyan-900 text-[10px] sm:text-xs whitespace-nowrap transition font-medium">
            Watch videos
          </button>
        ) : (
          <span className="text-jp-muted text-[10px] sm:text-xs">-</span>
        )}
      </td> */}

      {/* ACTIONS */}
      <td className="px-2 sm:px-3 py-2 sm:py-3 sticky right-0 bg-jp-card z-10">
        <div className="flex flex-row gap-1 sm:gap-2 min-w-[160px] sm:min-w-[180px]">
          <button
            onClick={handleViewProfile}
            className="border border-jp-line bg-jp-section text-jp-ink py-1 px-2 sm:px-3 rounded-md text-[10px] sm:text-xs leading-tight hover:bg-jp-section transition whitespace-nowrap"
          >
            View profile
          </button>
          <button
            onClick={handleFollowToggle}
            disabled={isLoading}
            className={`${
              isFollowing
                ? 'bg-gray-600 hover:bg-gray-700'
                : 'bg-cyan-500 hover:bg-cyan-400'
            } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''} text-white font-semibold py-1 px-2 sm:px-3 rounded-md text-[10px] sm:text-xs leading-tight transition whitespace-nowrap flex items-center justify-center gap-1`}
          >
            {isLoading ? (
              <>
                <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>{isFollowing ? 'Unfollowing...' : 'Following...'}</span>
              </>
            ) : (
              <span>{isFollowing ? 'Unfollow' : 'Follow'}</span>
            )}
          </button>
        </div>
      </td>
    </tr>
  );
};
